import {Controller} from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    widgetId = null;

    ensureTurnstileIsSet(timeout = 5000) {
        const start = Date.now();

        return new Promise(waitForTurnstile);

        function waitForTurnstile(resolve, reject) {
            // eslint-disable-next-line no-undef
            if (typeof turnstile !== 'undefined') resolve(turnstile);
            else if (timeout && Date.now() - start >= timeout) reject(new Error('timeout'));
            else setTimeout(waitForTurnstile.bind(this, resolve, reject), 30);
        }
    }

    connect() {
        // eslint-disable-next-line no-undef
        this.ensureTurnstileIsSet().then(() => {
            // eslint-disable-next-line no-undef
            this.widgetId = turnstile.render('#turnstile-container', {
                // eslint-disable-next-line no-unused-vars
                callback: (token) => {
                    const submitButton = this.element.querySelector('button[type="submit"]');
                    if (submitButton) {
                        submitButton.removeAttribute('disabled');
                    }
                },
            });
            console.warn('turnstile loaded');
        });
    }

    disconnect() {
        if (this.widgetId) {
            // eslint-disable-next-line no-undef
            turnstile.remove(this.widgetId);
        }
    }
}
